import * as React from 'react';
import Container from '@mui/material/Container';
import { useNavigate} from "react-router-dom";
import {withStyles} from "@mui/styles";
import {useEffect} from "react";
import {connect} from "trim-redux";
import {Styles} from "../../../../../config/design/styles";
import Grid from "@mui/material/Grid2";
import Logo from "../../../elements/Logo";
import {Button, IconButton, List, ListItem, Typography} from "@mui/material";
import {Facebook, Instagram, Linkedin,X} from "lucide-react";
import {WhatsApp} from "@mui/icons-material";
import SubTitle from "../../../elements/SubTitle";
import {useTranslation} from "react-i18next";
import IOSImg from '../../../../../files/img/apps/ios.png';
import AndroidImg from '../../../../../files/img/apps/android.png';
import {defaultVariables} from "../../../../../config";
import CopyrightFooter from "../../../elements/CopyrightFooter";
import {getOrderedIndustries} from "../../../../../config/industries";
function AppFooter({classes,user,isAuth,panel,setting}) {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const orderedIndustries = getOrderedIndustries(setting);

    return (
        <footer className={classes.footer}>
            <Container maxWidth="xl">
                <Grid container spacing={2}>
                    <Grid item size={{xs:12,md:5}}>
                        <Logo style={{marginBottom:20,width:160}}/>
                        <Typography>{setting.footer_text}</Typography>
                        <div className="social-holder">
                            {
                                !!setting.instagram_url &&
                                <IconButton component="a" target="_blank" href={setting.instagram_url}>
                                    <Instagram className="social-icon"/>
                                </IconButton>
                            }
                            {
                                !!setting.facebook_url &&
                                <IconButton component="a" target="_blank" href={setting.facebook_url}>
                                    <Facebook className="social-icon"/>
                                </IconButton>
                            }
                            {
                                !!setting.x_url &&
                                <IconButton component="a" target="_blank" href={setting.x_url}>
                                    <X className="social-icon"/>
                                </IconButton>
                            }
                            {
                                !!setting.linkedin_url &&
                                <IconButton  component="a" target="_blank" href={setting.linkedin_url}>
                                    <Linkedin className="social-icon"/>
                                </IconButton>
                            }
                            {
                                !!setting.whatsapp_url &&
                                <IconButton  component="a" target="_blank" href={setting.whatsapp_url}>
                                    <WhatsApp className="social-icon"/>
                                </IconButton>
                            }
                        </div>
                        <div className="payment-logos-holder">
                            <img src="/PMLOGOS.png" alt="payment-method-logos" loading="lazy"/>
                        </div>
                    </Grid>
                    <Grid item size={{xs:6,md:2}}>
                        <SubTitle align="left">{t('about')}</SubTitle>
                        <List dense>
                            {
                                (setting.footer_menu_1_text && setting.footer_menu_1_link) &&
                                <ListItem >
                                    <a  href={setting.footer_menu_1_link} target="_blank">
                                        {setting.footer_menu_1_text}
                                    </a>
                                </ListItem>
                            }
                            {
                                (setting.footer_menu_2_text && setting.footer_menu_2_link) &&
                                <ListItem>
                                    <a href={setting.footer_menu_2_link} target="_blank">
                                        {setting.footer_menu_2_text}
                                    </a>
                                </ListItem>
                            }
                            {
                                (setting.footer_menu_3_text && setting.footer_menu_3_link) &&
                                <ListItem>
                                    <a href={setting.footer_menu_3_link} target="_blank">
                                        {setting.footer_menu_3_text}
                                    </a>
                                </ListItem>
                            }
                            {
                                (setting.footer_menu_4_text && setting.footer_menu_4_link) &&
                                <ListItem>
                                    <a href={setting.footer_menu_4_link} target="_blank">
                                        {setting.footer_menu_4_text}
                                    </a>
                                </ListItem>
                            }
                        </List>
                    </Grid>
                    <Grid item size={{xs:6,md:2}}>
                        <SubTitle align="left">{t('quickAccess')}</SubTitle>
                        <List dense>
                            {orderedIndustries.map((industry) => (
                                <ListItem key={industry}>
                                    <a href={`${defaultVariables.website}/${industry}`} target="_blank">
                                        {t(industry)}
                                    </a>
                                </ListItem>
                            ))}
                            {/*<ListItem>
                                <a href={`${defaultVariables.website}/charities`} target="_blank">
                                    {t('charities')}
                                </a>
                            </ListItem>*/}
                            <ListItem>
                                <a href={`${defaultVariables.website}/contact`} target="_blank">
                                    {t('contactUs')}
                                </a>
                            </ListItem>
                            <ListItem>
                                <a href={`${defaultVariables.website}/app`} target="_blank">
                                    {t('androidApps')}
                                </a>
                            </ListItem>
                        </List>
                    </Grid>
                    <Grid item size={{xs:12,md:3}}>
                        <SubTitle align="left">{t('applications')}</SubTitle>
                        {
                            !!setting.ios_url &&
                            <a  href={setting.ios_url} target="_blank" className="footer-app">
                                <img src={IOSImg} alt='ios-app' loading="lazy" width={200}/>
                            </a>
                        }
                        {
                            !!setting.android_url &&
                            <a href={setting.android_url} target="_blank" className="footer-app">
                                <img src={AndroidImg} alt='android-app' loading="lazy" width={200}/>
                            </a>
                        }
                    </Grid>
                    <Grid item size={{xs:12}} style={{textAlign:"center"}}>
                       <CopyrightFooter/>
                    </Grid>
                </Grid>
            </Container>
        </footer>
    );
}
const mapStateToProps = (state) => ({
    isAuth: state.isAuth,
    setting: state.setting,
});

export default withStyles(Styles)(connect(mapStateToProps)(AppFooter));
